import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── Global styles ─────────────────────────────────────────────────────────────
const style = document.createElement('style');
// Static CSS only — use textContent (not innerHTML) so the string is never
// parsed as HTML.
style.textContent = `
  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: #f7f3f4;
    /* Prevent iOS rubber-band on body; pages handle their own scroll */
    overscroll-behavior: none;
  }

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  /* ── Section entrance animation (BDS v1.1) ── */
  @keyframes hhms-fade-in-up {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0);   }
  }
  .hhms-fade-in {
    animation: hhms-fade-in-up 280ms ease-out both;
  }
  .hhms-grid-stagger > * {
    animation: hhms-fade-in-up 280ms ease-out both;
  }
  .hhms-grid-stagger > *:nth-child(1) { animation-delay: 0ms; }
  .hhms-grid-stagger > *:nth-child(2) { animation-delay: 50ms; }
  .hhms-grid-stagger > *:nth-child(3) { animation-delay: 100ms; }
  .hhms-grid-stagger > *:nth-child(4) { animation-delay: 150ms; }
  .hhms-grid-stagger > *:nth-child(5) { animation-delay: 200ms; }
  .hhms-grid-stagger > *:nth-child(6) { animation-delay: 250ms; }
  .hhms-grid-stagger > *:nth-child(7) { animation-delay: 300ms; }
  .hhms-grid-stagger > *:nth-child(8) { animation-delay: 350ms; }
  @media (prefers-reduced-motion: reduce) {
    .hhms-fade-in,
    .hhms-grid-stagger > * { animation: none; }
  }

  /* ── Smooth scrolling everywhere ── */
  html { scroll-behavior: smooth; }

  /* ── Tables: native momentum scroll on iOS ── */
  .hhms-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* ── Modal entrance animation ── */
  @keyframes hhms-modal-in {
    from { opacity: 0; transform: scale(0.98); }
    to   { opacity: 1; transform: scale(1);    }
  }
  @media (prefers-reduced-motion: reduce) {
    [style*="hhms-modal-in"] { animation: none; }
  }

  /* ── Bottom-sheet slide-up animation ── */
  @keyframes hhms-sheet-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0);    }
  }

  /* ── Tap highlight — remove default blue flash on mobile ── */
  a, button, [role="button"] {
    -webkit-tap-highlight-color: transparent;
  }

  /* ── Input / select mobile font size fix (prevents iOS zoom on focus) ── */
  input, select, textarea {
    font-size: 16px !important;
  }
  @media (min-width: 769px) {
    input, select, textarea {
      font-size: 13px !important;
    }
  }

  /* ── Responsive page heading ── */
  @media (max-width: 768px) {
    h1 { font-size: 18px !important; }
  }

  /* ── Responsive summary card grids ── */
  @media (max-width: 640px) {
    .hhms-cards-3 { grid-template-columns: 1fr 1fr !important; }
    .hhms-cards-4 { grid-template-columns: 1fr 1fr !important; }
  }
  @media (max-width: 400px) {
    .hhms-cards-3 { grid-template-columns: 1fr !important; }
    .hhms-cards-4 { grid-template-columns: 1fr !important; }
  }
`;
document.head.appendChild(style);

// ── Root render ───────────────────────────────────────────────────────────────
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
